import request from '@/utils/request';

// 获取菜单
// export function getMenu(data) {
//   return request({
//     url: '/exam/getMenu',
//     method: 'get',
//     params: data,
//   });
// }
//查询当前菜单
export function getMenu(data) {
  return request({
    url: '/exam/getMenu',
    method: 'get',
    params: data,
  });
}
//查询当前考试阶段
export function queryExamPhase(data) {
  return request({
    url: '/exam/queryPhase',
    method: 'get',
    params: data,
  });
}
